import { Vector2Utils } from '../../../Types/IVector2';
import { BreadthFirstPathfinder } from './BreadthFirstPathfinder';
var UnweightedGridGraph = (function () {
    function UnweightedGridGraph(width, height, allowDiagonalSearch) {
        if (allowDiagonalSearch === void 0) { allowDiagonalSearch = false; }
        this.walls = [];
        this._neighbors = [];
        this._width = width;
        this._height = height;
        this._dirs = allowDiagonalSearch ? UnweightedGridGraph.COMPASS_DIRS : UnweightedGridGraph.CARDINAL_DIRS;
    }
    UnweightedGridGraph.prototype.isNodeInBounds = function (node) {
        return 0 <= node.x && node.x < this._width && 0 <= node.y && node.y < this._height;
    };
    UnweightedGridGraph.prototype.isNodePassable = function (node) {
        return !this.walls.find(function (wall) { return Vector2Utils.equals(wall, node); });
    };
    UnweightedGridGraph.prototype.getNeighbors = function (node) {
        this._neighbors.length = 0;
        for (var _i = 0, _a = this._dirs; _i < _a.length; _i++) {
            var dir = _a[_i];
            var next = Vector2Utils.add(node, dir);
            if (this.isNodeInBounds(next) && this.isNodePassable(next)) {
                this._neighbors.push(next);
            }
        }
        return this._neighbors;
    };
    UnweightedGridGraph.prototype.searchPath = function (start, goal) {
        return BreadthFirstPathfinder.searchPath(this, start, goal);
    };
    UnweightedGridGraph.prototype.hasPath = function (start, goal) {
        return BreadthFirstPathfinder.search(this, start, goal);
    };
    UnweightedGridGraph.CARDINAL_DIRS = [
        Vector2Utils.create(1, 0),
        Vector2Utils.create(0, -1),
        Vector2Utils.create(-1, 0),
        Vector2Utils.create(0, 1)
    ];
    UnweightedGridGraph.COMPASS_DIRS = [
        Vector2Utils.create(1, 0),
        Vector2Utils.create(1, -1),
        Vector2Utils.create(0, -1),
        Vector2Utils.create(-1, -1),
        Vector2Utils.create(-1, 0),
        Vector2Utils.create(-1, 1),
        Vector2Utils.create(0, 1),
        Vector2Utils.create(1, 1),
    ];
    return UnweightedGridGraph;
}());
export { UnweightedGridGraph };
